import { orderBy } from "lodash";
import { defaultKursusholdUnderviserColumns } from "../../../../../config/kursusConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../person/id/OpretNyButtonBlock";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { kursusUndervisereForm } from "../../../../../config/form/kursus/kursusUndervisereFormConfig";
import { Kursushold } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "kursusholdUnderviser.person.fuldtNavn",
  },
];

export default function KursusUndervisere({
  kursushold,
  invalidateData,
}: {
  kursushold: Kursushold;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "KursusWrite");
  const [kursusholdUnderviserColumns, setKursusholdUnderviserActiveColumns] =
    useActiveColumns(
      "kursus-kursusholdundervisere-active-columns",
      defaultKursusholdUnderviserColumns,
    );

  const { kursusholdUnderviser } = kursushold;

  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "kursusUndervisereSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  if (kursusholdUnderviser.length === 0) {
    return (
      <IngenRegistreringer
        invalidateData={invalidateData}
        editConfig={
          canWrite
            ? kursusUndervisereForm(kursushold.id, kursusholdUnderviser)
            : undefined
        }
      />
    );
  }

  return (
    <ModalProvider>
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            {getHeaderActiveColumns(kursusholdUnderviserColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            kursusholdUnderviser,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((underviser, i) => {
            return (
              <TableRow
                key={i}
                editConfig={
                  canWrite
                    ? kursusUndervisereForm(
                        kursushold.id,
                        kursusholdUnderviser,
                        underviser.id,
                      )
                    : undefined
                }
                invalidateData={invalidateData}
              >
                <>
                  {kursusholdUnderviserColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return (
                        <TD key={col.field} col={col} rowData={underviser} />
                      );
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultKursusholdUnderviserColumns}
        columns={kursusholdUnderviserColumns}
        setActiveColumns={setKursusholdUnderviserActiveColumns}
      />
      <OpretNyButtonBlock
        editConfig={
          canWrite
            ? kursusUndervisereForm(kursushold.id, kursusholdUnderviser)
            : undefined
        }
        invalidateData={invalidateData}
      />
    </ModalProvider>
  );
}
